// console.log(VueScrollTo);
var $ = require( "jquery" );
var ScrollMagic = require('scrollmagic');


var Extension = {};
var Controller = Extension;

Controller = {
	standby: function (root) {
		this.root = root;

		this.view = {};
		this.view.window = $(window);
		// this.view.window.on('resize', this.resize.bind(this));
		this.view.spBr = $('.sp__bnr');
		this.view.footer = $('#footer');

		$(document).on('click', 'a[href^="#"]', this.anchor.bind(this));		
		this.scrollMagic(this);
		this.view.window.scroll(this.scroll.bind(this));

	},
	scroll : function() {
		// if(this.view.keyvisual.length > 0) {
		// 	this.fixed();
		// }else {
			if(this.view.window.scrollTop() > 100 && this.view.window.scrollTop()+ this.view.window.height() < this.view.footer.offset().top) {
				this.view.spBr.addClass('fade-show');
			} else {
				this.view.spBr.removeClass('fade-show');
			}

		// }
	},
	// resize: function () {
	// 	this.view.window.w = window.innerWidth;

	// 	if (this.view.window.get(0).matchMedia('(max-width: 767px)').matches) {
	// 		if (this.device != 'SP') {
	// 			this.device = 'SP';
	// 			this.view.window.trigger('resize:SP');
	// 			this.view.window.trigger('resize:responsive');
	// 		}
	// 	} else {
	// 		if (this.device != 'PC') {
	// 			this.device = 'PC';
	// 			this.view.window.trigger('resize:PC');
	// 			this.view.window.trigger('resize:responsive');
	// 		}
	// 	}
	// },
	imgRespon: function () {
		if (this.device === 'PC') {
			$('img[data-src]').each(function () {
				$(this).attr('src', $(this).data('src')).addClass("js-active");
			});
		}
		if (this.device === 'SP') {
			$('img[data-src]').each(function (index) {
				$(this).attr('src', $(this).data('src').replace(/^(.+)(\.[a-z]+)$/, '$1' + '.sp' + '$2')).addClass("js-active");
			});
		}
	},
	openAcordion: function (el) {
		var target = $(el.currentTarget);
		target.toggleClass("active");
		target.next().slideToggle();
	},


	anchor: function(e) {
		e.preventDefault();
		var target = $(e.currentTarget);

		$('html, body').animate({
			scrollTop: $(target.attr('href')).offset().top
		}, 500);
		// bodyScrollLock.clearAllBodyScrollLocks();
	},
	scrollMagic: function () {
		var controller = new ScrollMagic.Controller();
		var targets = $('.js-anime:not(:hidden)');
		var scenes = [];

		targets.each(function() {
			var target = this;
			var scene = new ScrollMagic.Scene({triggerElement : target, triggerHook : 0.75});
			scene.on('enter', function(e) {
				$(target).addClass('js-active');
			});
			// scene.on('leave', function(e) {
			// 	$(target).removeClass('js-active');
			// });
			scenes.push(scene);
		});
		controller.addScene(scenes);

	},


};

Controller.standby();

